/**
 * @generated SignedSource<<463840161eab5cfa47eb10ede04d600f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useInitializeDiningBookingWizard_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly firstName?: string | null | undefined;
      readonly id?: string;
      readonly lastName?: string | null | undefined;
      readonly profileImage?: {
        readonly publicId: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useInitializeDiningBookingWizard_session";
};
export type useInitializeDiningBookingWizard_session$key = {
  readonly " $data"?: useInitializeDiningBookingWizard_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitializeDiningBookingWizard_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitializeDiningBookingWizard_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "profileImage",
                  "plural": false,
                  "selections": [
                    {
                      "alias": "publicId",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "renderingKey",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "Member",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "52fec5093d59c891c02af23b2a61abc3";

export default node;
